<template>
  <q-card
    flat
    bordered>
    <q-card-section>
      <template v-if="details">
        <!-- User Info Section -->
        <InfoBox
          :label="details.full_name"
          class="q-mb-sm">
          <template #header-chip>
            <q-btn
              flat
              dense
              color="primary"
              :icon="symRoundedRefresh"
              @click="userStore.regenUserData()">
              <q-tooltip>Rafraichir données utilisateur</q-tooltip>
            </q-btn>
          </template>
          <!-- User Roles Section -->
          <div
            v-if="details.roles && details.roles.length > 0"
            class="q-mb-sm">
            <div class="row q-gutter-xs flex-wrap">
              <q-chip
                v-for="role in details.roles"
                :key="role"
                color="secondary"
                text-color="black"
                dense>
                {{ $t(`crudmodels.user.roles.${role}`) }}
              </q-chip>
            </div>
          </div>
          <div class="row items-center justify-center">
            <q-btn
              flat
              dense
              label="Se déconnecter"
              color="negative"
              :icon="symRoundedLogout"
              @click="userStore.logout()">
              <q-tooltip>Se déconnecter</q-tooltip>
            </q-btn>
          </div>
        </InfoBox>

        <InfoBox
          label="Version"
          :text="globalStore.appVersion">
          <template #header-chip>
            <q-btn
              flat
              dense
              sime="sm"
              color="negative"
              :icon="symRoundedResetSettings"
              @click="UpdateStore.uninstall()">
              <q-tooltip>Réinitialiser l'application</q-tooltip>
            </q-btn>
          </template>
          <div class="row items-center justify-between">
            <div class="text-warning">v{{ globalStore.appVersion }}</div>

            <div>
              <q-btn
                flat
                dense
                color="primary"
                :icon="symRoundedSystemUpdateAlt"
                @click="UpdateStore.checkForUpdates({ notification: true })">
                <q-tooltip>Vérifier Mises à jour</q-tooltip>
              </q-btn>
            </div>
          </div>
        </InfoBox>

        <!-- Dark Mode Toggle -->
        <InfoBox label="Thème" v-if="false">
          <div class="row items-center justify-between">
            <div class="text-body2">
              {{ appSettingsStore.darkMode ? 'Mode sombre' : 'Mode clair' }}
            </div>
            <q-btn
              flat
              dense
              :color="appSettingsStore.darkMode ? 'warning' : 'primary'"
              :icon="appSettingsStore.darkMode ? symRoundedLightMode : symRoundedDarkMode"
              @click="appSettingsStore.toggleDarkMode()">
              <q-tooltip>
                {{ appSettingsStore.darkMode ? 'Passer en mode clair' : 'Passer en mode sombre' }}
              </q-tooltip>
            </q-btn>
          </div>
        </InfoBox>
      </template>
    </q-card-section>
  </q-card>
</template>

<script lang="ts" setup>
import {
  symRoundedDarkMode,
  symRoundedLightMode,
  symRoundedLogout,
  symRoundedRefresh,
  symRoundedResetSettings,
  symRoundedSystemUpdateAlt,
} from '@quasar/extras/material-symbols-rounded'
import dayjs from 'dayjs'

import { useAppSettingsStore } from 'src/CrudManager/Core/stores/useAppSettingsStore'
import { useGlobalStore } from 'src/CrudManager/Core/stores/useGlobalStore'
import { useUpdateStore } from 'src/CrudManager/Core/stores/useUpdateStore'
import { useUserStore } from 'src/CrudManager/Core/stores/useUserStore'
import { computed } from 'vue'

const userStore = useUserStore()
const UpdateStore = useUpdateStore()
const appSettingsStore = useAppSettingsStore()
const details = computed(() => userStore.user)
const globalStore = useGlobalStore()
const buildDate = dayjs(import.meta.env.VITE_BUILD_DATE).format('YYYY-MM-DD HH:mm')
</script>

<style lang="scss" scoped>
.profile-card {
  width: 100%;

  :deep(.q-expansion-item__container) {
    border: none;
  }
}
</style>
